(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.rangeInputValueDisplay = {
    attach: function (context, settings) {
      $("#edit-sort-bef-combine").on("change", function() {
        if (window.matchMedia) {
          var mq = window.matchMedia('(min-device-width: 801px)');
          if (mq.matches) {
            $(this).parents("form").submit();
          }
        }
        else {
          $(this).parents("form").submit();
        }
      });
    },
  };

})(jQuery, Drupal);
